
<template>
  <div class="container-fluid">
    <div class="row form" style="margin-top: 5%;">
      <h1 class="text-xs-center" style="font-weight: bold">
        Welcome to the Nigeria Federal Ministry of Health Dashboards
      </h1>
      <p class="text-center" v-if="$route.query.redirect">
        <small style="color:teal">Login first to view a dashboard for your location.</small>
      </p>
      <div>
        <img class="img-center img-circle img-reponsive" src="static/img/login_logo.png"
        style="display: block; margin: 0 auto;" alt="Coat Of Arms">
      </div>
      <h2 class="text-center">Login</h2>
        <div class="text-center">
          <span><small>choose a location</small></span>
           <p>
             <!-- Enter a message here ... -->
            <!-- <small></small> -->
          </p>

          <form class="form-horizontal" xs6 @submit.prevent="login" autocomplete="off" >

            <!-- <label><input class="form-control" v-model="email" placeholder="username" v-focus></label> -->
            <label for="" class="">
                <multi-select v-model="selectedLocation" :options="optionLocations" :hide-selected="true" :searchable="true" :allow-empty="true" :show-labels="false" placeholder="Select location"></multi-select>
            </label>
            <!-- <label><input class="form-control" v-model="pass" placeholder="password" type="password"></label> -->
            <br/>
            <p v-if="error" class="" style="border-color: gray"><label class="red--text">Incorrect login details.</label></p>
            <v-btn type="submit" dark color='green' >Login</v-btn>

          </form>
        </div>
    </div>
  </div>
</template>

<script>

  import MultiSelect from 'vue-multiselect'
  import auth from './auth'
  export default {
    components: {MultiSelect},
    data () {
      return {
        selectedLocation: '',
        optionLocations: [
          "FMOH Director DPRS", "PERM. Sec. FMOH", "HMH FMOH",
          "FMOH Public Health", "FMOH ICT", "FMOH DPRS MnE",
          "NPHCDA ED", "NERICC", "NPHCDA DPRS", "Admin",
          // "Guest"
        ],
        email: '',
        pass: '',
        error: false
      }
    },
    methods: {
      login () {
        // auth.login(this.email, this.pass, this.selectedLocation, loggedIn => {
        auth.login(this.selectedLocation, loggedIn => {
          // console.log(this.email, this.pass, this.selectedLocation)
          if (!loggedIn) {
            this.error = true
          } else {
            this.$router.replace(this.$route.query.redirect || '/')
            // window.location.reload();
          }
        })
      }
    }
  }
</script>

<style>
  .error {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?afd15abe